export const LIST_SEARCH_TIMEOUT_DELAY_MS = 1000
